<template>
    <div class="text-editor">
        <QuillEditor ref="quillRef" :options="mergedOptions" v-model:content="editorContent" contentType="html" />
    </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const defaultToolbar = [
    ['bold', 'italic', 'underline', 'link'],
    [{ list: 'ordered' }, { list: 'bullet' }]
]

export default {
    name: 'TextEditor',
    components: { QuillEditor },
    props: {
        modelValue: { type: String, default: '' },
        options: { type: Object, default: () => ({}) }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            editorContent: this.modelValue,
            quillReady: false
        }
    },
    computed: {
        mergedOptions() {
            return {
                modules: {
                    toolbar: defaultToolbar,
                    ...(this.options.modules || {})
                },
                ...this.options
            }
        }
    },
    watch: {
        modelValue(newVal) {
            if (this.quillReady && newVal !== this.editorContent) {
                this.editorContent = newVal
            }
        },
        editorContent(newVal) {
            if (this.quillReady && newVal !== this.modelValue) {
                this.$emit('update:modelValue', newVal)
            }
        }
    },
    mounted() {
        this.quillReady = true
    }
}
</script>

<style scoped>
.text-editor {
    min-height: 200px;
}
</style>